import React from "react";
import style from './style.module.css';

const CardAdvisory = ({ advisoryState }) => {
  //   const dataItem = { img, name, position, specialInterest };

  const advisoryData = advisoryState.advisory;
  console.log('Advisory slice data:');
  console.log(advisoryData);

  return (
    <>
      <div className={style.autoContainers}>
        {/* <h1 className="text-center ">Board Members</h1> */}
        {/* <!-- Row with cards --> */}
        <div className="row clearfix" >
          {advisoryData.map((item, index) => {
            return (
              <div className="col-sm-12 col-md-6 col-lg-6" >
                <div className={style.directorsBlock}>
                  <div className="row g-1 clearfix" >
                    <div className="col-lg-5 col-md-12 col-sm-12" >
                      <div className="image-box">
                        <figure className="image">
                          <img key={`board_mem_img-${index}`} src={item.img} alt={item.name} />
                        </figure>
                      </div>
                    </div>

                    <div className="col-lg-7 col-md-12 col-sm-12">
                      <div className={style.directorsDetail}>
                        <p className="cardTitle">{item.name}</p>
                        <br />
                        <div className="cardDetails">
                          <p>{item.position}</p>
                          <br />

                          {item.specialInterest?.length >=1 && <p>Special Interest:</p>}

                          {item.specialInterest?.length >= 1 && (
                            <ul>
                              {item.specialInterest.map((spcl, i) =>
                                spcl ? <li key={i}><p>{spcl}</p></li> : null
                              )}
                            </ul>
                          )}
                          <br />


                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* <!-- End of row with cards --> */}
      </div>
    </>
  );
};

export default CardAdvisory;
